var React = require('react');

function Night (props) {
    return React.createElement("svg",props,React.createElement("path",{"d":"M18.876 17.054a9.972 9.972 0 0 1-6.308 4.82C7.208 23.211 1.782 19.95.445 14.591c-1.073-4.304.82-8.652 4.382-10.89a10.452 10.452 0 0 0-.377 6.284c1.403 5.627 7.102 9.05 12.729 7.648a10.568 10.568 0 0 0 1.697-.58zm.694-7.444l-1.288 1.61 1.051 1.778-1.932-.724-1.367 1.547.094-2.064-1.894-.816 1.987-.547.197-2.06 1.142 1.726 2.01-.45zm-3.325-7.668L14.26 4.436l1.623 2.75-2.99-1.12-2.114 2.392.143-3.19-2.924-1.27 3.073-.859.303-3.167 1.754 2.654 3.117-.684z","fill":"currentColor","fillRule":"evenodd"}));
}

Night.defaultProps = {"width":"20","height":"23","viewBox":"0 0 20 23"};

module.exports = Night;

Night.default = Night;
